import React from 'react';
import getEnvironDomain from 'utils/getEnvironDomain';
import PopupLink from 'ati-ui-react/components/PopupLink';

import { FirmNameStyles } from './FirmNameStyles';

function FirmName({ account, mw, location }) {
  if (!account?.full_firm_name) return null;

  return (
    <FirmNameStyles location={location} mw={mw} onClick={(e) => e.stopPropagation()}>
      <PopupLink small href={`//${getEnvironDomain()}/firms/${account?.account_id}/info`}>
        {account?.full_firm_name}
      </PopupLink>
    </FirmNameStyles>
  );
}

export default FirmName;
